import React from 'react';
import { motion } from 'framer-motion';

const LegalPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl font-bold text-[#2c3e50] mb-8">
            Aviso Legal
          </h1>
          
          <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
            <div>
              <p className="text-gray-600 mb-6">
                <strong>Última actualización:</strong> 1 de enero de 2024
              </p>
              
              <p className="text-gray-600 leading-relaxed">
                Este aviso legal regula el uso del sitio web www.autosfersan.com, 
                propiedad de AUTOSFERSAN.
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                1. Datos Identificativos
              </h2>
              <div className="text-gray-600 leading-relaxed space-y-2">
                <p><strong>Denominación social:</strong> AUTOSFERSAN</p>
                <p><strong>Domicilio:</strong> Calle Isaac Peral, 31, Polígono La Mejostilla, 10004 Cáceres</p>
                <p><strong>Email:</strong> info@autosfersan.com</p>
                <p><strong>Teléfono:</strong> 610 70 15 17</p>
                <p><strong>Actividad:</strong> Venta de vehículos de segunda mano</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                2. Objeto
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  El presente aviso legal tiene por objeto regular el acceso y uso del sitio web 
                  www.autosfersan.com, así como las relaciones entre el sitio web y sus usuarios.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                3. Condiciones de Uso
              </h2>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <p>
                  El acceso a este sitio web implica la aceptación de estas condiciones de uso. 
                  El usuario se compromete a:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Hacer un uso correcto del sitio web</li>
                  <li>No realizar actividades ilícitas o que puedan dañar el sitio</li>
                  <li>No introducir virus o código malicioso</li>
                  <li>Respetar los derechos de propiedad intelectual</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                4. Responsabilidades
              </h2>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <h3 className="text-lg font-semibold text-[#2c3e50] mb-2">4.1 Del Sitio Web</h3>
                <p>
                  AUTOSFERSAN se esfuerza por mantener la información actualizada y correcta, 
                  pero no garantiza la exactitud, completitud o actualidad de la información contenida.
                </p>
                
                <h3 className="text-lg font-semibold text-[#2c3e50] mb-2 mt-6">4.2 Del Usuario</h3>
                <p>
                  El usuario es responsable de los daños y perjuicios que pueda causar por el uso 
                  inadecuado del sitio web.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                5. Propiedad Intelectual
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  Todos los contenidos del sitio web (textos, imágenes, sonidos, bases de datos, etc.) 
                  están protegidos por derechos de propiedad intelectual e industrial. Su uso no autorizado 
                  constituye una infracción punible por las leyes vigentes.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                6. Enlaces Externos
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  El sitio web puede contener enlaces a otros sitios web. AUTOSFERSAN no se hace 
                  responsable del contenido o las políticas de privacidad de estos sitios externos.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                7. Política de Cookies
              </h2>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <p>
                  Este sitio web utiliza cookies para mejorar la experiencia del usuario. 
                  Las cookies son pequeños archivos que se almacenan en su dispositivo.
                </p>
                
                <h3 className="text-lg font-semibold text-[#2c3e50] mb-2">Tipos de cookies que utilizamos:</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Cookies técnicas:</strong> Necesarias para el funcionamiento del sitio</li>
                  <li><strong>Cookies analíticas:</strong> Para analizar el uso del sitio web</li>
                  <li><strong>Cookies de personalización:</strong> Para recordar preferencias del usuario</li>
                </ul>
                
                <p>
                  Puede configurar su navegador para rechazar cookies, aunque esto puede afectar 
                  la funcionalidad del sitio web.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                8. Modificaciones
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  AUTOSFERSAN se reserva el derecho a modificar este aviso legal en cualquier momento. 
                  Los cambios serán efectivos desde su publicación en el sitio web.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                9. Legislación Aplicable
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  Este aviso legal se rige por la legislación española. Para cualquier controversia 
                  será competente la jurisdicción de Cáceres.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                10. Información sobre Vehículos
              </h2>
              <div className="text-gray-600 leading-relaxed space-y-4">
                <p>
                  La información sobre vehículos mostrada en este sitio web tiene carácter informativo. 
                  Las características, precios y disponibilidad pueden variar sin previo aviso.
                </p>
                
                <p>
                  Todos los vehículos están sujetos a inspección previa a la venta. Las fotografías 
                  pueden no corresponder exactamente al vehículo específico.
                </p>
                
                <p>
                  Los precios mostrados incluyen IVA cuando proceda. No incluyen gastos de transferencia, 
                  matriculación u otros gastos adicionales que se especificarán en el momento de la venta.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#2c3e50] mb-4">
                11. Contacto
              </h2>
              <div className="text-gray-600 leading-relaxed">
                <p>
                  Para cualquier consulta sobre este aviso legal, puede contactarnos:
                </p>
                <ul className="list-none mt-4 space-y-2">
                  <li><strong>Email:</strong> info@autosfersan.com</li>
                  <li><strong>Teléfono:</strong> 610 70 15 17</li>
                  <li><strong>Dirección:</strong> Calle Isaac Peral, 31, 10004 Cáceres</li>
                  <li><strong>Horario:</strong> Lunes a Viernes 9:00-14:00 y 16:00-19:00, Sábados 9:00-14:00</li>
                </ul>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalPage;